<table class="diff-table">
  <thead>
  <tr>
    <th>Field</th>
    <th>From</th>
    <th></th>
    <th>To</th>
  </tr>
  </thead>
  <tbody>
    @for (row of rows; track $index) {
      <tr>
        <td><code class="field-name">{{ row.field }}</code></td>
        <td><span class="val-from">{{ row.from }}</span></td>
        <td class="arrow">→</td>
        <td><span class="val-to">{{ row.to }}</span></td>
      </tr>
    }
  </tbody>
</table>
